






























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import multiLangEnter from "@/components/pages/ProductCreate/multiLangEnter.vue";
import skuEditMultiLang from "@/components/pages/ProductCreate/skuEditMultiLang.vue";
const Root = namespace("root");
/*
attrValueType
0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象'
*/
@Component({ components: { multiLangEnter, skuEditMultiLang } })
export default class attrValueSelect extends Vue {
  @Prop({ required: true, default: 0 })
  attrValueType!: number | null;
  @Prop({ required: true, default: "" })
  attrCode!: string;
  @Prop({ required: true, default: () => "" })
  dataValue!: any;
  @Prop({ default: () => {} }) sku;
  @Prop({ default: 0 }) attrIsLanguage;
  @Prop({ required: true, default: () => {} }) attr;
  @Prop({ default: false }) readonly;

  @Root.State languageList;
  attrValueList: any = null;
  attrValue: any = null;
  parmary: any = {
    codeList: [this.attrCode],
    orgCode: "default"
  };
  curLocale = localStorage.getItem("localeLanguage");
  @Watch("dataValue")
  onDataValueChange(val) {
    this.attrValueList = val;
  }
  @Watch("attrValueList")
  onAttrValueListChange(val) {
    this.$emit("update:dataValue", val);
  }
  mounted() {
    this.attrValueList = this.dataValue;
  }
  isAllMultiLang(item) {
    return this.languageList.every(_ => {
      let value = item ? item[_.value] : "";
      return !!value;
    });
  }
  editMultiOption() {
    this.$emit("editTextSku", this.attrCode);
  }
}
